import { useTheme } from "@/contexts/ThemeContext"
import { Toaster as Sonner } from "sonner"
import { logger } from '@/shared/utils/logger';
type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  let resolvedTheme = "light"
  
  try {
    const theme = useTheme()
    resolvedTheme = theme.resolvedTheme
  } catch (error) {
    // If we're outside ThemeProvider, use default theme
    logger.warn("Toaster: useTheme called outside ThemeProvider, using default theme")
  }

  return (
    <Sonner
      theme={resolvedTheme as ToasterProps["theme"]}
      className="toaster group"
      position="top-right"
      duration={3000}
      expand={false}
      richColors={true}
      closeButton={true}
      visibleToasts={3}
      toastOptions={{
        duration: 3000,
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:pointer-events-auto",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
        style: {
          pointerEvents: 'auto' as const,
        }
      }}
      style={{
        pointerEvents: 'none' as const,
      }}
      {...props}
    />
  )
}

// Re-export toast from the original sonner library
export { toast } from "sonner"
export { Toaster }
